"use client";

import { buildWhatsAppMessageLink } from "@/services/whatsapp-service";
import { countryCodes } from "@/utils/countryCodes";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import React, { FormEvent } from "react";
import { FaUsersViewfinder } from "react-icons/fa6";
import { useRouter } from "../i18n/navigation";
import { toast } from "sonner";

const OfferConfirmationModal = ({ isOpen, onClose, data }) => {
  const router = useRouter();
  const [userData, setUserData] = React.useState({
    fName: "",
    lName: "",
    email: "",
    mobile: "",
    code: "",
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState({
    status: false,
    message: "",
  });

  const submitHandler = async (e: FormEvent) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const formData = { userData, data };
      const response = await fetch("/api/v1/offer", {
        method: "POST",
        body: JSON.stringify(formData),
      });
      const res = await response.json();
      if (res) {
        setIsLoading(false);
        onClose();
        toast.success(
          "Your Quotation has been submitted! Redirecting to home page..."
        );
        router.replace("/");
        buildWhatsAppMessageLink(userData, data?.jet_type, data?.ref_no);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // Event handler to update the userData state on input changes
  const handleChange = (e: { target: { id: any; value: any } }) => {
    const { id, value } = e.target;
    setUserData((prevUserData) => ({
      ...prevUserData,
      [id]: value,
    }));
  };

  return (
    <>
      <Modal
        backdrop="blur"
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        placement="center"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <form onSubmit={(e) => submitHandler(e)}>
                <ModalHeader className="flex flex-col gap-1">
                  <div className="w-12 h-12 rounded-full bg-[#efefef] flex items-center justify-center">
                    <FaUsersViewfinder className="text-xl" />
                  </div>
                </ModalHeader>
                <ModalBody>
                  <h3 className="text-2xl font-medium">Personal Details</h3>
                  <p className="mb-4">
                    Please fill below form details and our team with get in
                    touch with you shortly!
                  </p>

                  <div className="flex item-center gap-4">
                    <Input
                      variant="bordered"
                      label="First Name"
                      size="sm"
                      id="fName"
                      value={userData.fName}
                      onChange={handleChange}
                      autoFocus
                      isRequired
                      autoComplete="false"
                    />
                    <Input
                      variant="bordered"
                      label="Last Name"
                      size="sm"
                      id="lName"
                      value={userData.lName}
                      onChange={handleChange}
                      isRequired
                      autoComplete="false"
                    />
                  </div>
                  <Input
                    variant="bordered"
                    label="Email"
                    type="email"
                    size="sm"
                    id="email"
                    value={userData.email}
                    onChange={handleChange}
                    isRequired
                    autoComplete="false"
                  />
                  <Input
                    autoComplete="false"
                    variant="bordered"
                    label="Mobile No."
                    type="tel"
                    size="sm"
                    id="mobile"
                    startContent={
                      <div className="flex items-center">
                        <label className="sr-only" htmlFor="code">
                          Code
                        </label>
                        <select
                          className="outline-none border-0 bg-transparent text-[#333] text-small"
                          id="code"
                          name="code"
                          onChange={handleChange}
                        >
                          {countryCodes.map(({ dial_code }, index) => {
                            return (
                              <option
                                key={index}
                                value={dial_code}
                                className="text-[#333]"
                              >
                                {dial_code}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    }
                    value={userData.mobile}
                    onChange={handleChange}
                    isRequired
                  />
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="danger"
                    variant="flat"
                    radius="sm"
                    onClick={onClose}
                    className="px-10"
                  >
                    Close
                  </Button>
                  <Button
                    onClick={submitHandler}
                    radius="sm"
                    className="px-10 bg-[#5a558e] text-white"
                    isLoading={isLoading}
                  >
                    Submit
                  </Button>
                </ModalFooter>
              </form>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default OfferConfirmationModal;
